import { DueDateValue } from "@smartsuite/types";
import { FieldRegistryConfig } from "../../types";
import { DueDateFieldControl } from "../due-date/DueDateFieldControl/DueDateFieldControl";
import { prefillDate } from "../date/date.config";
import { defaultDueDateValue } from "./due-date.helpers";
import { dateToDateValue } from "@smartsuite/fields-logic/lib/utils/date";
import { dueDateToReviewString } from "../review/reviewString.helpers";

interface DateValue {
  date: string | null;
  include_time: boolean;
}

const convertDateValue = (value: DateValue): DateValue => {
  if (!value.date) {
    return { ...value, date: "" };
  }

  return value.include_time
    ? { ...value, date: new Date(value.date).toISOString() }
    : { ...value, date: dateToDateValue(new Date(value.date), false).date };
};

export const dueDateFieldConfig: FieldRegistryConfig<DueDateValue> = {
  icon: "due-date",
  control: (props) => <DueDateFieldControl {...props} />,
  convertFormValueToApi: (value) => ({
    from_date: convertDateValue(value.from_date),
    to_date: convertDateValue(value.to_date),
  }),
  prefill: ({ value, config, field }) => {
    const [fromDate, toDate] = value.split(",");

    // Return null for empty input
    if (value === "," || !value) {
      return null;
    }

    // Handle single date (no comma) - should set to_date
    if (!value.includes(",")) {
      return {
        from_date: defaultDueDateValue.from_date,
        to_date: prefillDate({ value, field, config }) ?? defaultDueDateValue.to_date,
      };
    }

    return {
      from_date: fromDate
        ? prefillDate({ value: fromDate, field, config })
        : defaultDueDateValue.from_date,
      to_date: toDate ? prefillDate({ value: toDate, field, config }) : defaultDueDateValue.to_date,
    };
  },
  toReviewString: (value, _appField, preferences) =>
    dueDateToReviewString(value, preferences?.locale.time_format, preferences?.timezone?.value),
};
